import React from 'react';
import classNames from 'classnames';
import { Button } from '../../Button';
import { Search } from '../../../foundations/icons';
import styles from './Submit.module.scss';
var Submit = function (_a) {
    var _b;
    var active = _a.active;
    return (React.createElement(Button, { className: classNames(styles.button, (_b = {},
            _b[styles.active] = active,
            _b)), "data-actiontype": "search", "data-origincomponent": "SearchForm", "data-shortdescription": "search products", disabled: !active, type: "submit", startIcon: React.createElement(Search, { size: "small" }), "aria-label": "Search" }));
};
export { Submit };
//# sourceMappingURL=Submit.js.map